<template>
  <div id="app">
    <section class="header">
      <div class="header-wrapper">
        <a href="https://eyejackapp.com/" target="_blank">
          <img class="header-logo" src="@/assets/logo-red@2x.png" alt="EyeJack">
        </a>
        <div class="header-logo-container">
          <img id="logo" src="@/assets/webAR_logo.png" alt="EyeJack Web AR">
          <img id="logo-mobile" src="@/assets/webAR_logo_mobile.png" alt="EyeJack Web AR">
        </div>
        <div class="header-copy-container">
          <h1>EyeJack with WebAR</h1>
          <h3 class="red bold">Activate your Art with WebAR. No app required!</h3>
          <h3>Augmented Reality Art can now be accessed using WebAR. It simply works in your mobile browser (no app required) and you can link to it directly from your website.</h3>
          <a href="#demo" v-smooth-scroll>
            <button>Try it out now!</button>
          </a>
        </div>
      </div>
    </section>
    <section class="videos wrapper">
      <div class="video-row reverse">
        <div class="copy-container">
          <h3>Activate Art</h3>
          <p>Artists, Galleries and Museums can add a layer of Augmented Reality to their artworks and exhibitions.</p>
          <p>Using EyeJack WebAR, you can activate a single artwork or an entire collection!</p>
        </div>
        <div class="video-container">
          <video autoplay loop muted playsinline src="@/assets/eyejack-webar-gallery-comp.mp4"></video>
        </div>
      </div>
      <div class="video-row">
        <div class="copy-container">
          <h3>Activate Murals</h3>
          <p>Community Events, Art Walks and Tours can add another dimension to a local precinct.</p>
          <p>EyeJack WebAR integrates with maps, competitions and rewards for a richer public experience.</p>
        </div>
        <div class="video-container">
          <video autoplay loop muted playsinline src="@/assets/eyejack-webar-murals-comp.mp4"></video>
        </div>
      </div>
      <div class="video-row reverse">
        <div class="copy-container">
          <h3>Activate You</h3>
          <p>Augment your world with animation and sound.</p>
          <p>With EyeJack WebAR, its super easy to create and share your creations with others.</p>
        </div>
        <div class="video-container">
          <video autoplay loop muted playsinline src="@/assets/eyejack-webar-fashion-comp.mp4"></video>
        </div>
      </div>
      <div class="video-row">
        <div class="copy-container">
          <h3>Activate Brands</h3>
          <p>Brands and Agencies can use EyeJack WebAR technology to connect and wow their audience using Augmented Reality.</p>
          <p>No app download means a reduced barrier to entry and higher audience engagement.</p>
        </div>
        <div class="video-container">
          <video autoplay loop muted playsinline src="@/assets/eyejack-webar-brand-comp.mp4"></video>
        </div>
      </div>
    </section>
    <section class="demo" id="demo">
      <div class="wrapper">
        <div class="demo-header">
          <div class="demo-copy-container">
            <h1 class="red bold">WebAR Demo</h1>
            <img class="demo-qr" src="@/assets/demo-qrcode-plain.png">
            <div class="demo-spacer"></div>
            <h2>To view, open camera on smartphone and scan code</h2>
            <p class="bold">Or visit</p>
            <a href="https://eyejack.link/webardemo" target="_blank">
              <button class="bold">eyejack.link/webardemo</button>
            </a>
          </div>
          <img id="demo-image" src="@/assets/b592ae40-d68a-11e8-828a-1334c9ae6ae8-image.jpg">
        </div>
      </div>
      <div class="image-grid wrapper">
        <img id="grid-demo-image" src="@/assets/b592ae40-d68a-11e8-828a-1334c9ae6ae8-image-square.jpg">
        <img src="@/assets/cf6b1a10-d684-11e8-87b4-351ed2ed509b-image.jpg">
        <img src="@/assets/08b3f2e0-d687-11e8-828a-1334c9ae6ae8-image.jpg">
        <img src="@/assets/516fca90-d687-11e8-828a-1334c9ae6ae8-image.jpg">
        <img src="@/assets/0cc5dc30-d688-11e8-828a-1334c9ae6ae8-image.jpg">
        <img src="@/assets/6d3e35d0-d688-11e8-828a-1334c9ae6ae8-image.jpg">
        <img src="@/assets/04d0a160-d68b-11e8-828a-1334c9ae6ae8-image.jpg">
        <img src="@/assets/14185fa0-d68b-11e8-828a-1334c9ae6ae8-image.jpg">
        <img src="@/assets/115707a0-d689-11e8-828a-1334c9ae6ae8-image.jpg">
        <img src="@/assets/529e1490-d68b-11e8-828a-1334c9ae6ae8-image.jpg">
      </div>
    </section>
    <section class="get-in-touch wrapper">
      <h3>Interested in activating your art with WebAR?</h3>
      <a href="mailto:info@eyejackapp.com">
        <button>Get in touch!</button>
      </a>
    </section>
    <footer>
      <img id="footer-logo" src="./assets/ej-footer@2x.png" alt="EyeJack">
      <p>EyeJack © 2020 <a target="_blank" href="https://eyejackapp.com/pages/privacy">Privacy</a> and <a target="_blank" href="https://eyejackapp.com/pages/terms">Terms</a>.</p>
      <div class="social-links">
        <a target="_blank" href="https://www.facebook.com/eyejackapp/">
          <img id="fb-link" src="./assets/facebook-grey.svg" alt="Facebook">
        </a>
        <a target="_blank" href="https://www.instagram.com/eyejackapp/">
          <img id="ig-link" src="./assets/instagram-grey.svg" alt="Instagram">
        </a>
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
html, body {
  margin: 0;
}

* {
  box-sizing: border-box;
}

#app {
  font-family: 'Helvetica', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.wrapper {
  max-width: 1080px;
  margin: auto;
  padding: 0 30px;
}

h1 {
  font-size: 42px;
  font-weight: 100;
  margin-bottom: 20px;
}

h3 {
  font-weight: 200;
  font-size: 20px;
}

.red {
  color: #FF5C5E;
}

.bold {
  font-weight: 600;
}

section {
  margin: 60px 0;
}

.header {
  height: 100vh;
  max-height: 1024px;
  background: #F3F3F3;
  margin: 0;
  display: flex;
}

.header-wrapper {
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
  display: flex;
}

.header-logo-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 30px;
  width: 35%;
}

.header-logo-container > img {
  /* max-width: 350px; */
  /* height: auto; */
  object-fit: contain;
  margin-left: -30px;
}

#logo {
  display: block;
}

#logo-mobile {
  display: none;
}

.header-copy-container {
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: center;
}

.header-logo {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 92px;
  height: auto;
}

.header-logo:hover {
  cursor: pointer;
}

.videos {
  padding-top: 40px;
}

.video-row {
  display: flex;
  max-height: 520px;
}

.video-row:not(:last-child) {
  margin-bottom: 40px;
}

.reverse {
  flex-direction: row-reverse;
}

.reverse > .copy-container {
  padding: 0 0 0 20px;
}

.copy-container {
  flex-grow: 1;
  padding: 0 20px 0 0;
}

.video-container {
  padding: 20px;
  flex-grow: 1;
  max-width: 50%;
}

video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.copy-container > h3 {
  font-size: 30px;
}

.copy-container > h3::after {
  content: "";
  display: block;
  border-bottom: 1px solid #FF5C5E;
  height: 20px;
  width: 130px;
  margin-bottom: 50px;
}

.copy-container > p {
  font-size: 20px;
  font-weight: 200;
}

.demo {
  background: #f3f3f3;
  padding-top: 60px;
}

.demo-header {
  max-width: 100%;
  display: flex;
  max-height: 600px;
  margin-bottom: 60px;
}

.demo-header > img {
  display: inline;
  height: auto;
}

#demo-copy {
  width: 46%;
}

#demo-image {
  max-width: 60%;
  height: auto;
  max-height: 520px;
  object-fit: contain;
  margin-top: auto;
}

#grid-demo-image {
  display: none;
}

.demo-copy-container {
  display: flex;
  flex-direction: column;
  padding-right: 40px;
  justify-content: space-between;
}

.demo-copy-container > h1 {
  margin-top: 0;
}

.demo-copy-container > p {
  font-size: 18px;
  margin-top: 0;
}

.demo-qr {
  width: 230px;
  height: auto;
  border-radius: 20px;
}

.demo-spacer {
  width: 50px;
  height: 30px;
  border-bottom: 1px solid #FF5C5E;
}

.image-grid {
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
  margin-top: 20px;
  padding-bottom: 60px;
}

.image-grid > img {
  width: 100%;
  height: auto;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25); */
}

.get-in-touch {
  text-align: center;
  margin-bottom: 60px;
}

button {
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 18px;
  color: #ffffff;
  background: #FF5C5E;
  transition: background 0.2s;
  outline: none;
  border: none;
}

button:hover {
  background: #CF3A3C;
  cursor: pointer;
}

footer {
  background: #3C3C3B;
  padding: 20px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

#footer-logo {
  width: 121px;
  margin-bottom: 8px;
}

footer > p {
  color: #ffffff;
}

footer > p > a {
  color: #4A90E2;
  text-decoration: none;
}

#fb-link {
  margin-right: 20px;
}

@media screen and (max-width: 769px) {
  .header-wrapper {
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }

  .header-logo-container {
    width: inherit;
  }

  .header-logo-container > img {
    margin-left: 0;
    width: 130px;
  }

  .header-logo {
    left: auto;
    right: 20px;
    width: 60px;
  }

  .header-copy-container > h1 {
    margin-top: 20px;
  }

  .header-copy-container > h3 {
    margin-top: 0;
  }

  #logo {
    display: none;
  }

  #logo-mobile {
    display: block;
    height: 100%;
  }

  .image-grid {
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;
  }

  .video-row {
    flex-direction: column-reverse;
    max-height: none;
  }

  .video-container {
    padding: 0 !important;
    height: auto;
    width: 100%;
    max-width: none;
  }

  .copy-container {
    padding: 0 !important;
  }

  #demo-image {
    display: none;
  }

  #grid-demo-image {
    display: block;
  }
}
</style>
